// * Bootstrap libraries
import './_bootstrap';

// * Any other global site-wide JavaScript should be placed below.

(function($) {
    $(document).ready(function() {

        // всплывашки с формами
        $('.fancy-form').fancybox({
            touch: false
        });

        // лицензии
        $('.views-field-field-license-image').photobox('a',{ time:0 });

        // фото продукции
        $('.node--type-products .group-left').photobox('a',{ time:0 });

        // слайдер на главной
        $('.view-slider .view-content').slick({
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            prevArrow: $('.slide_prev'),
            nextArrow: $('.slide_next'),
        });

        // лицензии на главной
        $('.path-frontpage .view-license-block .view-content').slick({
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: $('.license_prev'),
            nextArrow: $('.license_next'),
            responsive: [
                { breakpoint: 768,
                    settings: { slidesToShow: 3} },
                { breakpoint: 480,
                    settings: { slidesToShow: 2} }
            ]
        });

        // mobile menu
        $('.navmobile_button .btn_open').on('click',function() {
            $(this).toggleClass('btn_active');
            $('.btn_close').toggleClass('btn_active');
            $('#nav_mobile').toggleClass('mobile_menu_active');
        });
        $('.nav_mobile_wrapper .btn_close').on('click',function() {
            $(this).toggleClass('btn_active');
            $('.btn_open').toggleClass('btn_active');
            $('#nav_mobile').toggleClass('mobile_menu_active');
        });

        $('.nav_mobile_background').on('click',function() {
            $('.btn_close').removeClass('btn_active');
            $('.btn_open').removeClass('btn_active');
            $('#nav_mobile').removeClass('mobile_menu_active');
        });

        function checkMyCookies(){
            let cookieDate = localStorage.getItem('cookieDate');
            let cookieNotification = document.getElementById('cookie_notifys');
            let cookieBtn = cookieNotification.querySelector('.notifys__apply');
            if( !cookieDate || (+cookieDate + 31536000000) < Date.now() ){
                cookieNotification.classList.add('show');
            }
            cookieBtn.addEventListener('click', function(){
                localStorage.setItem( 'cookieDate', Date.now() );
                cookieNotification.classList.remove('show');
            })
        }
        checkMyCookies();

    });
})(jQuery);